import {Authentication, AuthenticationRequest, AuthenticationResponse} from './types.js';
import {exceptionInfo} from '../common/types.js';

export interface Authenticator {
    // returns a promise that will either be resolved or rejected depending on the authentication result
    authenticate(request: AuthenticationRequest): Promise<AuthenticationResponse>

    stop(): void
}

export function authenticateSecret(authentication: Authentication): Promise<AuthenticationResponse> {
    const {login, secret} = authentication;
    if (login && (secret || secret === '')) {
        return Promise.resolve({type: 'success', user: login, login})
    }
    return Promise.reject(exceptionInfo("Missing login/secret", {type: 'failure', message: 'Missing login/secret'}));
}

export function gatewayToken(authentication?: Authentication): string | undefined {
    if (isGatewayTokenAuthentication(authentication)) {
        return authentication.token;
    }
    return undefined;
}

export function isGatewayTokenAuthentication(authentication?: Authentication): authentication is Authentication & { method: 'gateway-token' } {
    return authentication?.method === 'gateway-token';
}
export function isGatewayClientAuthentication(authentication?: Authentication): authentication is Authentication & { method: 'gateway-client' } {
    return authentication?.method === 'gateway-client';
}
